module.exports = require('./helpers/bundle-url').getBundleURL('7lpHJ') + "logo@2x.cf27bf02.png";